// ======================================
// Testimonials Page Module
// ======================================

import { icons, renderTestimonialCard } from '../components.js';
import { testimonialsAPI } from '../lib/api.js';

export function renderTestimonialsPage() {
  return `
    <section class="page-header">
      <div class="container">
        <div class="page-header-content">
          <h1 class="page-title">What Our Clients Say</h1>
          <p class="page-subtitle">
            Real stories from real homeowners. See why 500+ families 
            trust NammaVeetuInteriors with their dream homes.
          </p>
        </div>
      </div>
    </section>

    <!-- Stats Bar -->
    <section style="background-color: var(--color-primary); padding: var(--space-8) 0;">
      <div class="container">
        <div class="testimonial-stats">
          <div class="testimonial-stat">
            <div class="testimonial-stat-value">500+</div>
            <div class="testimonial-stat-label">Happy Homes</div>
          </div>
          <div class="testimonial-stat">
            <div class="testimonial-stat-value">4.9</div>
            <div class="testimonial-stat-label">Google Rating</div>
          </div>
          <div class="testimonial-stat">
            <div class="testimonial-stat-value">98%</div>
            <div class="testimonial-stat-label">Would Recommend</div>
          </div>
          <div class="testimonial-stat">
            <div class="testimonial-stat-value">10+</div>
            <div class="testimonial-stat-label">Years Experience</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Grid -->
    <section class="section" style="background-color: var(--color-base);">
      <div class="container">
        <div id="testimonials-grid" class="testimonials-grid" style="min-height: 200px;">
          <div style="grid-column: 1/-1; text-align: center; padding: 40px;">Loading testimonials...</div>
        </div>
      </div>
    </section>

    <!-- Google Reviews CTA -->
    <section class="section" style="background-color: var(--color-surface);">
      <div class="container">
        <div class="google-reviews-banner">
          <div class="google-reviews-content">
            <div class="google-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
            </div>
            <div>
              <h3 class="google-reviews-title">See Our Google Reviews</h3>
              <p class="google-reviews-desc">
                4.9 ★ rating from 200+ verified reviews
              </p>
            </div>
          </div>
          <a href="https://g.page/nammaveetuinteriors/review" target="_blank" class="btn btn-secondary">
            Read Reviews ${icons.arrowRight}
          </a>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="section cta-section">
      <div class="container">
        <div class="cta-content">
          <h2 class="cta-title">Ready to Join Our Happy Clients?</h2>
          <p class="cta-subtitle">
            Start your interior transformation today with a free consultation.
          </p>
          <button class="btn btn-lg cta-btn" data-open-modal="lead-modal">
            Book Free Consultation
          </button>
        </div>
      </div>
    </section>
  `;
}

export function initTestimonialsPage() {
  loadTestimonials();
}

async function loadTestimonials() {
  const grid = document.getElementById('testimonials-grid');
  if (!grid) return;

  try {
    const response = await testimonialsAPI.list();
    const items = Array.isArray(response) ? response : (response.items || []);

    if (items.length === 0) {
      grid.innerHTML = '<div style="grid-column: 1/-1; text-align: center; color: var(--color-text-muted);">No testimonials yet.</div>';
      return;
    }

    grid.innerHTML = items.map(t => renderTestimonialCard(t)).join('');
  } catch (error) {
    console.error('Failed to load testimonials:', error);
    grid.innerHTML = '<div style="grid-column: 1/-1; text-align: center; color: var(--color-error);">Failed to load testimonials.</div>';
  }
}
